import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = { class: "checkbox" }
const _hoisted_7 = { class: "control" }
const _hoisted_8 = { class: "checkbox" }
const _hoisted_9 = { class: "control" }
const _hoisted_10 = { class: "checkbox" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "control" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "control" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "control" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_23 = { class: "field" }
const _hoisted_24 = { class: "control" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_27 = { class: "field" }
const _hoisted_28 = { class: "control" }
const _hoisted_29 = { class: "field has-addons" }
const _hoisted_30 = { class: "control is-expanded" }
const _hoisted_31 = { class: "control" }
const _hoisted_32 = { class: "icon" }
const _hoisted_33 = { class: "field" }
const _hoisted_34 = { class: "control" }
const _hoisted_35 = { class: "field has-addons" }
const _hoisted_36 = { class: "control is-expanded" }
const _hoisted_37 = { class: "control" }
const _hoisted_38 = { class: "icon" }

import { required } from '@vuelidate/validators';
import { appsApi } from '@/features/apps/shared/services/apps';
import { PrivateApp, UpdatePrivateAppViewModel } from '@/features/apps/shared/models';
import Toast from '@/shared/services/toast';
import { HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';
import { useStore } from 'vuex';
import { computed, onBeforeMount, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import useVuelidate from '@vuelidate/core';
import { useClipboard } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditPrivateApp',
  emits: ["loading", "loaded"],
  setup(__props, { emit: __emit }) {

const url = (value: string) => {
  if (!value) {
    return true;
  }
  return value.startsWith('http://') || value.startsWith('https://');
};

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const handleSeriousError = (error: string) => store.dispatch(HANDLE_SERIOUS_ERROR, error);
const route = useRoute();
const router = useRouter();

const actionInProgress = ref(false);
const app = ref<PrivateApp>({
  id: '',
  name: '',
  ownerWorkspaceId: '',
  apiToken: '',
  capabilities: {
    supportsWebhooks: false,
    supportsBotAction: false,
    supportsHomescreen: false,
  },
  workflowOptions: {
    configUrl: '',
    initUrl: '',
    submitUrl: '',
    webhookUrl: '',
    verificationToken: '',
    webhookTopics: [],
  },
});

const validations = {
  app: {
    name: { required },
    workflowOptions: {
      configUrl: { url },
      initUrl: { url },
      submitUrl: { url },
      webhookUrl: { url },
    },
  },
};

const $v = useVuelidate(validations, { app });

const emit = __emit;

function supportsAppLifecycleHooks() {
  return app.value.capabilities.supportsHomescreen || app.value.capabilities.supportsBotAction;
}

onBeforeMount(() => {
  emit('loading');
  if (!currentWorkspace.value) {
    handleSeriousError('No workspace selected');
    return;
  }

  appsApi
    .getPrivateApp(currentWorkspace.value.id, <string>route.params.id)
    .then((fetchedApp) => {
      app.value = fetchedApp;
    })
    .catch((err) => {
      handleSeriousError(err.message);
    })
    .finally(() => emit('loaded'));
});

const { copy, copied } = useClipboard();

const copyToClipboard = async (toCopyText: string) => {
  try {
    await copy(toCopyText);
    if (copied) {
      Toast.showInfo('Copied to clipboard');
    }
  } catch (err) {
    console.error('Failed to copy text: ', err);
  }
};

function save() {
  if (actionInProgress.value) {
    return;
  }

  actionInProgress.value = true;

  const request = {
    appName: app.value.name,
    capabilities: app.value.capabilities,
    workflowOptions: app.value.workflowOptions,
  } as UpdatePrivateAppViewModel;

  appsApi
    .updatePrivateApp(currentWorkspace.value.id, app.value.id, request)
    .then(() => {
      Toast.showSuccess('App config saved');
      router.push({ name: 'private-apps-list' });
    })
    .catch((err) => Toast.showError(err.message))
    .finally(() => (actionInProgress.value = false));
}

function cancel() {
  router.push({ name: 'private-apps-list' });
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("fieldset", null, [
      _createElementVNode("div", _hoisted_1, [
        _cache[19] || (_cache[19] = _createElementVNode("label", { class: "label" }, "App Name", -1)),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { 'is-danger': _unref($v).app.name.$invalid && _unref($v).app.name.$dirty }]),
            type: "text",
            placeholder: "Enter app name here",
            required: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((app.value.name) = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref($v).app.name.$touch()))
          }, null, 34), [
            [
              _vModelText,
              app.value.name,
              void 0,
              { trim: true }
            ]
          ]),
          (_unref($v).app.name.$invalid && _unref($v).app.name.$dirty)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "The app name is required"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[23] || (_cache[23] = _createElementVNode("label", { class: "label" }, "Capabilities", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((app.value.capabilities.supportsBotAction) = $event))
            }, null, 512), [
              [_vModelCheckbox, app.value.capabilities.supportsBotAction]
            ]),
            _cache[20] || (_cache[20] = _createTextVNode(" Supports bot action "))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((app.value.capabilities.supportsHomescreen) = $event))
            }, null, 512), [
              [_vModelCheckbox, app.value.capabilities.supportsHomescreen]
            ]),
            _cache[21] || (_cache[21] = _createTextVNode(" Supports homescreen "))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((app.value.capabilities.supportsWebhooks) = $event))
            }, null, 512), [
              [_vModelCheckbox, app.value.capabilities.supportsWebhooks]
            ]),
            _cache[22] || (_cache[22] = _createTextVNode(" Supports webhooks "))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[24] || (_cache[24] = _createElementVNode("label", { class: "label" }, "Config URL", -1)),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", {
              'is-danger': _unref($v).app.workflowOptions.configUrl.$invalid && _unref($v).app.workflowOptions.configUrl.$dirty,
            }]),
            type: "text",
            placeholder: "Enter config URL here",
            required: "",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((app.value.workflowOptions.configUrl) = $event)),
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_unref($v).app.workflowOptions.configUrl.$touch())),
            disabled: !supportsAppLifecycleHooks()
          }, null, 42, _hoisted_13), [
            [
              _vModelText,
              app.value.workflowOptions.configUrl,
              void 0,
              { trim: true }
            ]
          ]),
          (_unref($v).app.workflowOptions.configUrl.$invalid && _unref($v).app.workflowOptions.configUrl.$dirty)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Must be a valid URL "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[25] || (_cache[25] = _createElementVNode("label", { class: "label" }, "Init URL", -1)),
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { 'is-danger': _unref($v).app.workflowOptions.initUrl.$invalid && _unref($v).app.workflowOptions.initUrl.$dirty }]),
            type: "text",
            placeholder: "Enter init URL here",
            required: "",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((app.value.workflowOptions.initUrl) = $event)),
            onInput: _cache[8] || (_cache[8] = ($event: any) => (_unref($v).app.workflowOptions.initUrl.$touch())),
            disabled: !supportsAppLifecycleHooks()
          }, null, 42, _hoisted_17), [
            [
              _vModelText,
              app.value.workflowOptions.initUrl,
              void 0,
              { trim: true }
            ]
          ]),
          (_unref($v).app.workflowOptions.initUrl.$invalid && _unref($v).app.workflowOptions.initUrl.$dirty)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Must be a valid URL "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[26] || (_cache[26] = _createElementVNode("label", { class: "label" }, "Submit URL", -1)),
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", {
              'is-danger': _unref($v).app.workflowOptions.submitUrl.$invalid && _unref($v).app.workflowOptions.submitUrl.$dirty,
            }]),
            type: "text",
            placeholder: "Enter submit URL here",
            required: "",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((app.value.workflowOptions.submitUrl) = $event)),
            onInput: _cache[10] || (_cache[10] = ($event: any) => (_unref($v).app.workflowOptions.submitUrl.$touch())),
            disabled: !supportsAppLifecycleHooks()
          }, null, 42, _hoisted_21), [
            [
              _vModelText,
              app.value.workflowOptions.submitUrl,
              void 0,
              { trim: true }
            ]
          ]),
          (_unref($v).app.workflowOptions.submitUrl.$invalid && _unref($v).app.workflowOptions.submitUrl.$dirty)
            ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Must be a valid URL "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _cache[27] || (_cache[27] = _createElementVNode("label", { class: "label" }, "Webhook URL", -1)),
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", {
              'is-danger': _unref($v).app.workflowOptions.webhookUrl.$invalid && _unref($v).app.workflowOptions.webhookUrl.$dirty,
            }]),
            type: "text",
            placeholder: "Enter webhook URL here",
            required: "",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((app.value.workflowOptions.webhookUrl) = $event)),
            onInput: _cache[12] || (_cache[12] = ($event: any) => (_unref($v).app.workflowOptions.webhookUrl.$touch())),
            disabled: !app.value.capabilities.supportsWebhooks
          }, null, 42, _hoisted_25), [
            [
              _vModelText,
              app.value.workflowOptions.webhookUrl,
              void 0,
              { trim: true }
            ]
          ]),
          (_unref($v).app.workflowOptions.webhookUrl.$invalid && _unref($v).app.workflowOptions.webhookUrl.$dirty)
            ? (_openBlock(), _createElementBlock("p", _hoisted_26, " Must be a valid URL "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _cache[28] || (_cache[28] = _createElementVNode("label", { class: "label" }, "Verification Token", -1)),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                disabled: "",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((app.value.workflowOptions.verificationToken) = $event))
              }, null, 512), [
                [_vModelText, app.value.workflowOptions.verificationToken]
              ])
            ]),
            _createElementVNode("p", _hoisted_31, [
              _createElementVNode("button", {
                class: "button is-info",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (copyToClipboard(app.value.workflowOptions.verificationToken)))
              }, [
                _createElementVNode("span", _hoisted_32, [
                  _createVNode(_component_font_awesome_icon, { icon: "copy" })
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _cache[29] || (_cache[29] = _createElementVNode("label", { class: "label" }, "API Token", -1)),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                disabled: "",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((app.value.apiToken) = $event))
              }, null, 512), [
                [_vModelText, app.value.apiToken]
              ])
            ]),
            _createElementVNode("p", _hoisted_37, [
              _createElementVNode("button", {
                class: "button is-info",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (copyToClipboard(app.value.apiToken)))
              }, [
                _createElementVNode("span", _hoisted_38, [
                  _createVNode(_component_font_awesome_icon, { icon: "copy" })
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_n_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            variant: "primary",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (save())),
            disabled: _unref($v).$invalid,
            loading: actionInProgress.value
          }, {
            default: _withCtx(() => _cache[30] || (_cache[30] = [
              _createTextVNode("Submit")
            ])),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_n_button, {
            onClick: _cache[18] || (_cache[18] = ($event: any) => (cancel())),
            variant: "primary--outline"
          }, {
            default: _withCtx(() => _cache[31] || (_cache[31] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})